module.exports = __webpack_public_path__ + "img/57.41a8665a.png";